import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { connect } from 'react-redux';

import { MODAL_CLOSE } from 'redux/slices/modals';

import { Icon, Button } from 'ui/atoms';
import { Container } from 'ui/gridSystem';
import MainFont from 'ui/typography/mainFont';

import {
  IconClose,
  ModalGlobalContainer,
  ModalTitle,
  ModalWrapper
} from '../Modal.style';

import { Buttons, ModalContainer, ModalContent, ModalHeader } from './style';

import Modal, { stopEvent } from '../Modal';
import { push } from 'redux-first-history';

const modalId = 'ConfirmModal';

const ConfirmModal = ({ onClose, payload }) => {
  const { t } = useTranslation();

  const history = useHistory();

  return (
    <Modal id={modalId}>
      <Container>
        <ModalWrapper>
          <ModalGlobalContainer
            onMouseDown={stopEvent}
            onClick={stopEvent}
            width="791px"
            height="auto"
          >
            <ModalTitle>
              <MainFont type="4" configuration={{ fontSize: 24 }}>
                {t('hey_wait')}
              </MainFont>
              <IconClose>
                <Icon type="icon-close-modal" size={20} onClick={onClose} />
              </IconClose>
            </ModalTitle>
            <ModalContainer>
              <ModalContent>
                <ModalHeader>
                  <MainFont type="description" configuration={{ fontSize: 16 }}>
                    {t('go_back_modal_content')}
                  </MainFont>
                </ModalHeader>
              </ModalContent>
            </ModalContainer>
            <Buttons>
              <Button variant="popupCancel" onClick={() => onClose()}>
                {t('no_wait')}
              </Button>
              <Button
                variant="popupYes"
                onClick={() => {
                  onClose();
                  history.block((location, action) => true);
                  history.push(payload);
                }}
              >
                {t('go_back')}
              </Button>
            </Buttons>
          </ModalGlobalContainer>
        </ModalWrapper>
      </Container>
    </Modal>
  );
};

ConfirmModal.propTypes = {
  onClose: PropTypes.func || PropTypes.string
};

ConfirmModal.id = modalId;

export default connect(
  state => ({
    payload: state.modals?.payload
  }),
  dispatch => ({
    onClose: () => dispatch(MODAL_CLOSE()),
    pushUrl: url => dispatch(push(url))
  })
)(ConfirmModal);
